'use client';

import { useMemo } from 'react';

const formatClock = (secondsValue) => {
  if (!Number.isFinite(secondsValue)) return '--:--';
  const safe = Math.max(0, Math.floor(secondsValue));
  const hours = Math.floor(safe / 3600);
  const mins = Math.floor((safe % 3600) / 60);
  const secs = safe % 60;
  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export default function DailyPhaseTimer({ phase = 'live', secondsToSubmissionClose = null, secondsToVoteClose = null, secondsToResultsReveal = null }) {
  const content = useMemo(() => {
    if (phase === 'calculating') {
      return {
        label: 'Results are currently calculating',
        value: 'Please check back shortly',
      };
    }

    const submitSeconds = Number.isFinite(secondsToSubmissionClose) ? secondsToSubmissionClose : null;
    const voteSeconds = Number.isFinite(secondsToVoteClose) ? secondsToVoteClose : null;
    const fallback = submitSeconds ?? voteSeconds;
    return {
      label: 'Submissions close in',
      value: formatClock(fallback),
      subLabel: Number.isFinite(voteSeconds) ? `Voting closes in ${formatClock(voteSeconds)}` : null,
    };
  }, [phase, secondsToSubmissionClose, secondsToVoteClose]);

  return (
    <section className="dailyPage__card">
      <div className="dailyPage__timerLabel">{content.label}</div>
      <div className="dailyPage__timerValue">{content.value}</div>
      {content.subLabel ? <div className="dailyPage__counterSecondary">{content.subLabel}</div> : null}
    </section>
  );
}
